<template>
  <div class="card mb-4 d-flex" v-bind:id="'poster' + poster.abstract_id">
    <router-link :to="'/viewer/' + poster.abstract_id" class="text-center pt-1" v-if="thumbnails === true">
      <img class="img-fluid align-middle mb-1"
           v-lazy="getImgUrl(poster.content.poster)"
           v-bind:alt="poster.title">
    </router-link>
    <div class="card-body alert-primary pb-1">
      <router-link :to="'/viewer/' + poster.abstract_id" class="card-text small font-weight-bolder block-ellipsis"
                   v-html="poster.title">
      </router-link>
    </div>
    <div class="card-footer alert-primary">
      <div class="">
        <small class="text-muted">{{ poster.presentation_code }}</small>
        <small class="text-muted float-right">{{ _.groupCapital }}: {{ poster.grouped }}</small>
      </div>
      <span class="text-center">
              <UserShare :poster="poster.abstract_id" :title="poster.title"
                         v-if="shareShow == poster.abstract_id" class="mb-1"/>
              <router-link class="btn btn-link btn-sm pl-0" :to="'/viewer/' + poster.abstract_id">
                <icon :icon="['fad', 'eye']"/> View
              </router-link>
              <router-link v-if="poster.content.audio != null" class="btn btn-link btn-sm ml-1"
                           :to="'/viewer/' + poster.abstract_id">
                <icon :icon="['fad', 'volume']"/> Audio
              </router-link>
              <router-link class="btn btn-link btn-sm ml-1" :to="'/viewer/video/' + poster.abstract_id"
                           v-if="poster.content.video != null">
                <icon :icon="['fad', 'video']"/> Video
              </router-link>
              <!--button class="btn btn-link btn-sm ml-1" v-on:click="toggleShare(poster.abstract_id)">
                <icon :icon="['fad', 'share']"/>
                Sharevv
              </button-->
              <router-link class="btn btn-link btn-sm ml-1" :to="'/mail/' + poster.abstract_id">
                <icon :icon="['fad', 'envelope']"/>
                Contact
              </router-link>
            </span>
      <span class="float-right my-auto small font-weight-bold">
            Rating: {{ ratings[poster.id].rating }} ({{ ratings[poster.id].count }} votes)
          </span>
    </div>
  </div>
</template>
<script>
import Rating from "../Rating"
import UserShare from "../UserShare"
import {mapState} from 'vuex'

export default {
  name: 'Card',
  components: {Rating, UserShare},
  props: {
    poster: {},
    shareShow: {},
  },
  computed: {
    ...mapState(
        ['ratings', "thumbnails"]
    ),
  },
  methods: {
    getImgUrl(src) {
      return process.env.VUE_APP_PATH_FILESERVERURL + src + '/resize/' + process.env.VUE_APP_THUMBNAIL_WIDTH + '/' + process.env.VUE_APP_THUMBNAIL_HEIGHT;
      // return process.env.VUE_APP_PATH_S3URL + src + '-' + process.env.VUE_APP_THUMBNAIL_WIDTH + '-' + process.env.VUE_APP_THUMBNAIL_HEIGHT + '-1-undefined-image';
    },
    toggleShare: function (poster) {
      if (this.shareShow != poster) {
        this.shareShow = poster;
      } else {
        this.shareShow = null;
      }
    },
  },
}
</script>
<style scoped>
@media (min-width: 10em) {
}

.block-ellipsis {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  margin: 0 auto;
  font-size: 14px;
  line-height: 1;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
